import { css } from 'styled-components';
import { boxShadowNone, boxShadowStandard } from '@nib-components/theme';
import { map } from '../../breakpoint';
const mapStringToSelector = (string)=>{
    switch(string){
        case 'none':
            return boxShadowNone;
        case 'standard':
            return boxShadowStandard || 'hsla(0, 0%, 0%, .13) 0px 4px 8px 0px';
    }
};
export const boxShadow = ()=>css`
  ${({ boxShadow })=>map(boxShadow, (val)=>val !== undefined && css`
          box-shadow: ${mapStringToSelector(val)};
        `)};
`;

//# sourceMappingURL=box-shadow.js.map